import styled from 'styled-components';
import media from '../theme/media';

export const Container = styled.div`
  
  padding: 0 1.5rem;
  margin: 0 auto;
  
  display: flex;
  max-width: 88rem;
  align-items: center;
  justify-content: space-between;
  min-height: calc(100vh - 11rem);
  
  &.true {
      display: block;
      max-width: 58.5rem;
  }
`;

export const ContainerLarge = styled.div`
  max-width: 79rem;
  margin: 0 auto;
  padding: 0 2rem;
  ${media.phone`
    padding: 0 1.5rem;
  `}
`;

export const Article = styled.article`
  margin: 12rem 0 6rem 0;
  &.false {
    margin: 5.5rem 0;
  }
  ${media.phone`
    margin: 0;
  `}
`;

export const Heading = styled.header`
  padding: 1rem 0;
  text-align: left;
  margin: 0;
  width: 30%;
  
  &.true {
    margin: 7rem 2rem 3.5rem 2rem;
    text-align: center;
    width: auto;
  }
  
  ${media.small`
    &.true {
      margin: 6rem auto 2rem auto
    }
  `}
`;

export const Hero = styled.figure`
  padding: 2rem 0;
  ${media.phone`
    order: 1;
    padding: 2.5rem 0;
  `}
`;

export const Section = styled.section`
  padding: 5rem 0 0 0;
  position: relative;
  display: none;
  &:nth-last-of-type(1) {
    padding: 5rem 0 5rem 0;
  }
  ${media.phone`
    flex-direction: column;
    padding: 2rem 0 0 0;
    &.mobileHide {
      display: none;
    }
  `}
  &.true {
    display: block;
    ${media.phone`
      display: flex;
      flex-direction: column;
    `}
  }
`;

export const KeySection = styled.section`
  position: relative;
  padding: 0;
  width: 60%;
  > span {
    display: none;
  }
  ${media.phone`
    display: flex;
    flex-direction: column;
    &.mobileHide {
      display: none;
    }
  `}
  &.true {
    width: auto;
    padding: 5rem 0 0 0;
    > span {
      display: block;
    }
  }
  &.none.true {
    display: none;
  }
`;

export const FirstSection = styled.section`
  margin: 0;
  position: relative;
  display: none;
  ${media.small`
    flex-direction: column;
  `}
  &.true {
    display: block;
    ${media.small`
      display: flex;
    `}
  }
`;

export const MobileFlex = styled.div`
  ${media.phone`
    display: flex;
    flex-direction: column;
  `}
`;

export const SideColumn = styled.div`
  position: absolute;
  top: 16px;
  width: 200px;
  right: -240px;
  ${media.phone`
    width: 100%;
    order: 2;
    position: static;
  `}
`;

export const SideColumnLeft = styled.div`
  position: absolute;
  width: 124px;
  left: -86px;
  top: calc(50% - 22px);
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export const SideColumnRight = styled.div`
  position: absolute;
  width: 124px;
  right: -86px;
  top: calc(50% - 22px);
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export const SideColumnRightSkwiz = styled.div`
    position: absolute;
    width: 124px;
    right: -62px;
    top: calc(50% - 150px);
    ${media.tablet`
      order: 2;
      position: static;
      margin: 4rem auto;
    `}
`;

export const SideColumnBookLeft = styled.div`
  position: absolute;
  width: 150px;
  top: calc(50% - 72px);
  left: -56px;
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export const SideColumnBookRight = styled.div`
  position: absolute;
  width: 150px;
  top: calc(50% - 72px);
  right: -56px;
  ${media.tablet`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;

export const SideColumnLeftLarge = styled.div`
  position: absolute;
  width: 300px;
  left: -192px;
  top: calc(50% - 108px);
  ${media.desktop`
    order: 2;
    position: static;
    margin: 8rem auto 0 auto;
  `}
  ${media.phone`
    order: 2;
    position: static;
    margin: 4rem auto;
  `}
`;
export const SideColumnRightLarge = styled.div`
  position: absolute;
  width: 300px;
  right: -160px;
  top: calc(50% - 72px);
  ${media.desktop`
    order: 2;
    position: static;
    margin: 8rem auto 0 auto;
  `}
  ${media.phone`
    display: none;
  `}
`;

export const MainColumn = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 480px;
  width: 100%;
  position: relative;
  order: 1;
  ${media.phone`
      
  `}
`;


export const Figure = styled.figure`
  margin: 0;
  width: 100%;
  position: relative;
  > img {
    box-shadow: 0 1px 0 rgba(255,255,255,.6), 0 2px 40px 4px #ccced0;
  }
  ${media.phone`
    order: 3;
    margin: 2rem 0;
  `}
`;

export const FigureSmall = styled.figure`
margin: 0 2rem;
width: calc(50% - 4rem);
  ${media.phone`
    margin: 4rem 0;
    width: 100%;
    order: 3;
  `}
`;

export const OneThird = styled.div`
  vertical-align: top;
  display: inline-block;
  width: calc((21/68) * 100%);
  border: 8px solid #1e1f21;
  border-radius: 32px;
  &:nth-child(2) {
    margin: 0 calc((2.5/68) * 100%);
    ${media.phone`
        display: none;
    `}
  }
  img {
    display: block;
    border-radius: 24px;
    ${media.phone`
        border-radius: 32px;
    `}
  }
  ${media.phone`
      border-radius: 40px;
      width: 100%;
      &:nth-child(1) {
        margin-bottom: 56px;
      }
  `}
  
`;

export const OneHalf = styled.div`
  vertical-align: middle;
  display: inline-block;
  width: 45%;
  &:nth-child(1) {
    margin: 0 10% 0 0;
  }
  &.right {
    text-align: right;
  }
  ${media.phone`
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    &:nth-child(1) {
      margin: 0 auto;
    }
    &.reorder {
      order: 2;
    }
    &.right {
      text-align: center;
    }
  `}
`;

export const MobileHide = styled.div`
  ${media.phone`
    display: none;
  `}
`;

export const MobileShow = styled.div`
  display: none;
  ${media.phone`
    display: block;
  `}
`;

export const DesktopHide = styled.div`
  display: none;
  ${media.phone`
    display: block;
  `}
`;



// WEBPACK FOOTER //
// src/theme/grid.js